import { DefaultOptions, QueryClient } from '@tanstack/react-query';

export const serverDefaultOptions: DefaultOptions = {
  queries: {
    staleTime: 0,
    gcTime: 1000 * 60 * 5,
    retry: false,
    retryDelay: (attemptIndex: number) => Math.min(1000 * 2 ** attemptIndex, 30000),
    refetchOnWindowFocus: false,
  },
};
export const browserDefaultOptions: DefaultOptions = {
  queries: {
    staleTime: 5 * 1000 * 60,
    gcTime: 10 * 1000 * 60,
    retry: false,
    retryDelay: (attemptIndex: number) => Math.min(1000 * 2 ** attemptIndex, 30000),
    refetchOnWindowFocus: false,
  },
};

// We can not useState or useRef in a server component, which is why we are
// extracting this part out into it's own file with 'use client' on top
export function makeQueryClient() {
  if (typeof window === 'undefined') {
    return new QueryClient({
      defaultOptions: serverDefaultOptions,
    });
  }

  return new QueryClient({
    defaultOptions: browserDefaultOptions,
  });
}
